import React, { useEffect } from 'react'
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"

import { object, string } from "yup"
import { useValidatorSeeker } from "@app"
import { AutocompleteAjaxSeeker, TextFieldSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"
import { batch, useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"

export default function UserCompanyField() {

	const { company, setCompanyInfo } = useAdminUsersInfo(userPayload.peek()?.user?.company, "company", "user")
	const options = useSignal([])
	const newCompany = useSignal("")

	const { errors, isValid } = useValidatorSeeker(
		{ company: company },
		object({
			company: string().required('Must provide a company')
		})
	)

	useEffect(() => {
		userErrorRegistry.value = { ...userErrorRegistry.peek(), company: isValid }
	}, [isValid])

	return <Box sx={{ display: "flex", alignItems: "start", justifyContent: "space-evenly", flexDirection: "row", gap: 2 }}>
		<AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
			urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/companies`}
			onFinishAjax={opts => options.value = opts}
			options={options.value}
			value={company}
			label="Company"
			placeholder="Company"
			onChange={e => setCompanyInfo(e.target.value)}
			error={errors?.company}
		/>
		<TextFieldSeeker
			value={newCompany.value}
			label="New Company"
			placeholder="Add new company"
			onChange={e => batch(() => {
				newCompany.value = e.target.value
				const existingOption = options.value.find(({ label }) => label === e.target.value)

				if (!e.target.value) {
					options.value = options.value.slice(0, -1)
				} else if (existingOption) {
					setCompanyInfo(existingOption?.value)
				} else {
					options.value = [...options.value.slice(0, -1), { label: e.target.value, value: e.target.value }]
				}
				setCompanyInfo(e.target.value)
			})}

		/>
	</Box>
}